import React from 'react';
import { ArrowRightIcon, LockKeyholeIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://colorpack.store/cart/52065201717546:1?storefront=true';
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
};
export function CtaButton({
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} className={`group inline-flex w-full items-center justify-center gap-3 rounded-sm bg-[#d49a35] px-5 py-4 text-center text-sm font-extrabold tracking-[0.08em] text-[#111a2a] shadow-[0_5px_0_#8f5a16] transition hover:-translate-y-0.5 hover:bg-[#e4ad4b] hover:shadow-[0_7px_0_#8f5a16] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-[#f2c86f] sm:w-auto sm:min-w-[360px] ${className}`} data-id="element-13">
      <span data-id="element-14">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-15" />
    </a>;
}
export function SecureNote() {
  return <p className="mt-5 flex items-center justify-center gap-2 text-xs text-[#f5eddc]/75" data-id="element-16">
      <LockKeyholeIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-17" />
      Pago único · Acceso inmediato · Sin suscripciones
    </p>;
}
export { CHECKOUT_URL };